import { api } from '../../lib/api.ts';

export interface AddressEntry {
  id: string;
  officeName: string;
  addresseePerson: string | null;
  address: string | null;
  atoll: string | null;
  island: string | null;
  phone: string | null;
  email: string | null;
}

export type AddressEntryInput = Omit<AddressEntry, 'id'>;

export const addressBookApi = {
  list: () => api.get<{ entries: AddressEntry[] }>('/address-book').then((r) => r.data.entries),
  create: (input: Partial<AddressEntryInput> & { officeName: string }) =>
    api.post<{ entry: AddressEntry }>('/address-book', input).then((r) => r.data.entry),
  update: (id: string, patch: Partial<AddressEntryInput>) =>
    api.patch<{ entry: AddressEntry }>(`/address-book/${id}`, patch).then((r) => r.data.entry),
  remove: (id: string) => api.delete(`/address-book/${id}`),
};
